import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { Exact } from "@Helpers/types/exact";
import { setCurrencyDetails } from "../reducers/currency";
import type {
  SaveCurrencyRequest,
  SaveCurrencyResponse,
  GetSymbolsDataRequest,
  GetSymbolsDataResponse,
  DeleteCurrencyRequest,
  DeleteCurrencyResponse,
  SaveSelectedCurrencyRequest,
  SaveSelectedCurrencyResponse,
  GetDefaultCurrencyDetailForProjectLevelRequest,
  GetDefaultCurrencyDetailForProjectLevelResponse,
} from "@ServerTypes/currency/currency.schema";

export const SaveCurrencyData = async <T extends Exact<SaveCurrencyRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<SaveCurrencyResponse>(`${getBackendUrl()}/currency/saveCurrencyData`, data);
  return response;
};

export const getSymbolsData = async <T extends Exact<GetSymbolsDataRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<GetSymbolsDataResponse>(`${getBackendUrl()}/currency/getSymbolsData`, data);
  return response;
};
export const DeleteCurrencyData = async <T extends Exact<DeleteCurrencyRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<DeleteCurrencyResponse>(
    `${getBackendUrl()}/currency/deleteCurrencyData`,
    data,
  );
  return response;
};
export const saveSelectedCurrencyData = async <T extends Exact<SaveSelectedCurrencyRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<SaveSelectedCurrencyResponse>(
    `${getBackendUrl()}/currency/saveSelectedCurrencyData`,
    data,
  );
  return response;
};

export const getDefaultCurrencyDetailForProjectLevel = async <
  T extends Exact<GetDefaultCurrencyDetailForProjectLevelRequest, T>,
>(
  data: T,
) => {
  const response = await axiosWrapper.post<GetDefaultCurrencyDetailForProjectLevelResponse>(
    `${getBackendUrl()}/currency/getDefaultCurrencyDetailForProjectLevel`,
    data,
  );
  return response;
};
export const getCurrencyData =
  <T extends Exact<GetDefaultCurrencyDetailForProjectLevelRequest, T>>(data: T) =>
  async (dispatch: AppDispatch) => {
    const response = await axiosWrapper.post<GetDefaultCurrencyDetailForProjectLevelResponse>(
      `${getBackendUrl()}/currency/getDefaultCurrencyDetailForProjectLevel`,
      data,
    );

    if (response.data.status) {
      const currencyObj = {
        currencyDetail: response.data.currencyDetail,
        symbolDetail: response.data.symbolDetail,
      };
      dispatch(setCurrencyDetails(currencyObj));
    }
  };
